import Light from 'themes/Light';
import Dark from 'themes/Dark';

export { Light, Dark };
export default { Light, Dark };
